export { default as ResultSection } from './Section';
